// import { ApproveInnovationAnnouce10Component } from "../../../components/SupportSystem/SupportForm/current/ApproveInnovationAnnouce10Component";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { ConsiderSupportInnovationComponent } from "../../../components/SupportSystem/SupportForm/current/ConsiderSupportInnovationComponent";


export function ApproveInnovationAnnouce10Container() {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            {/* <ApproveInnovationAnnouce10Component/> */}
            <ConsiderSupportInnovationComponent />

            <Footer />
        </div>
        // 
    )

}